/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ConferenceFormComponent as ConferenceForm } from './schedule_form/form_component.jsx';

export class ConferenceScheduleEditor extends React.Component {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    eventInstances: PropTypes.array
  };

  static defaultProps = {
    startDate: null,
    endDate: null,
    eventInstances: []
  };

  constructor(props) {
    super(props);
  }

  render() {
    return <ConferenceForm startDate={this.props.startDate}
                      endDate={this.props.endDate}
                      eventInstances={this.props.eventInstances}
    />;
  }
}
